module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover table-condensed table-responsive"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.lista), function(participante) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(participante.dorsal))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(participante.nome))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(participante.equipa))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(participante.escalao))])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Dorsal")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Equipa")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Escalão")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b14a01e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabelaValidados.vue
// module id = 267
// module chunks = 1